import './App.css';

import Router from '../src/Components/Router/Router';

function App() {
  return (
    <div className="App">
     <Router />
    </div>
  );
}

export default App;
